let apiUrl = "";

switch (window.origin) {
  case "http://localhost:3000":
    apiUrl = "http://localhost:8080";
    break;
  case "http://local.primstories.com:3000":
    apiUrl = "https://api.primstories.com";
    break;
  case "https://app.primstories.com":
    apiUrl = "https://api.primstories.com";
    break;
  default:
    apiUrl = window.origin.replace("3000", "8080");
    break;
}

export const API_URL = apiUrl;
export const WS_URL = `${apiUrl.replace("http", "ws")}/ws`;
export const STRIPE_PUBLISHABLE_KEY = "pk_test_51PgpsAKxRAxzz8mLFvOqk2t6ycadJk63nCztY7LYCz18P80O7THnvYN3gABT9pWfaaKBu3AcuQ2SB6HHXeVFICIr006KuTqjoG";
